export enum CostActions {
    Approve = 'approve',
    Reject = 'reject',
    Print = 'print',
    Export = 'export',
    Return = 'return',
    MarkAsReturned = 'markAsReturned',
    SendForApproval = 'sendForApproval',
    Cancel = 'cancel',
}
